"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpokenLanguageLevel = void 0;
/**
 * Mastery level, from 1 to 5.
 */
var SpokenLanguageLevel;
(function (SpokenLanguageLevel) {
    SpokenLanguageLevel[SpokenLanguageLevel["ONE"] = 1] = "ONE";
    SpokenLanguageLevel[SpokenLanguageLevel["TWO"] = 2] = "TWO";
    SpokenLanguageLevel[SpokenLanguageLevel["THREE"] = 3] = "THREE";
    SpokenLanguageLevel[SpokenLanguageLevel["FOUR"] = 4] = "FOUR";
    SpokenLanguageLevel[SpokenLanguageLevel["FIVE"] = 5] = "FIVE";
})(SpokenLanguageLevel = exports.SpokenLanguageLevel || (exports.SpokenLanguageLevel = {}));
//# sourceMappingURL=SpokenLanguageModel.js.map